// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__0DLdU","main":"Layout_main__WgF+C"};